var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "sui-container",
        [
          _c("sui-header", { tag: "h2", staticClass: "manager-header" }, [
            _vm._v("Settings"),
          ]),
          _c("Manager"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }